module.exports = __webpack_public_path__ + "media/andenes/carretilla_manual-47b155e2.webp";